import { Image, Flex, Spacer, Text } from "@chakra-ui/react";
import React, { memo, useEffect, useRef } from "react";
// import required modules
import SwiperComponent from "./swiper";
import WhyComponent from "./why";
import HowComponent from "./how";
import WhatComponent from "./what";
import ProjectSupportedComponent from "./support";
import BottomComponent from "./bottom";
import PricingComponent from "./pricing";
import { useLocation } from "react-router-dom";
import { useDocumentTitle, useImageIntersectionObserver, useLocalStorage, useShowBackToTopBtn } from "@/hooks";
function HomeComponent() {
   const location = useLocation()
   const pricingRef = useRef();
   const exampleRef = useRef();
   const [topShow] = useShowBackToTopBtn()
   const [locationKey, setLocationKey] = useLocalStorage('location-key')
   useDocumentTitle('AlohaBots | 1st Choice for NFT Sales Bot')
   useImageIntersectionObserver()
   useEffect(() => {
      if (locationKey !== location.key && location.state != null && location.state.jump) {
         if(location.state.type==='example'){
            exampleRef.current.scrollIntoView({ behavior: "smooth" });
         }else if(location.state.type==='price'){
            pricingRef.current.scrollIntoView({ behavior: "smooth" });
         }
         setLocationKey(location.key)
      }
   }, [location, locationKey, setLocationKey])
   return (
      <Flex pos={"relative"} flexDir={"column"} mt={"130px"} >
         <Image
            userSelect={'none'}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            left={0}
            top={"-100px"}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_left_icon.png"}
         />
         <Image
            userSelect={'none'}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            right={0}
            top={"120px"}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_right_icon.png"}
         />
         <Image
            userSelect={'none'}
            className="refImg"
            src={undefined}
            pos={"absolute"}
            right={50}
            top={"770px"}
            data-src={process.env.REACT_APP_PUBLIC_URL + "images/skin_bottom_icon.png"}
         />
         <Flex flexDir={'column'} w={'1280px'} mx={'auto'}>
            <Text fontSize={'50px'} color={'black'} fontFamily={'Arial-BoldMT'} zIndex={"1"} textAlign='center'>
               Aloha Twitter Bots for NFT Collections
            </Text>
            <Text textAlign={'center'} zIndex={1} fontSize={26} mb={'20px'} px={'250px'} >
               The most advanced and powerful tool to promote NFT projects and increase community engagement.
            </Text>
         </Flex>
         <SwiperComponent />
         <WhyComponent />
         <HowComponent />
         <WhatComponent />
         <Spacer ref={exampleRef} />
         <ProjectSupportedComponent />
         <Spacer ref={pricingRef} />
         <PricingComponent />
         {topShow && <Image
            boxSize={"42px"}
            display={topShow ? "block" : "none"}
            cursor={"pointer"}
            pos={"fixed"}
            userSelect={'none'}
            bottom={70}
            right={33}
            src={process.env.REACT_APP_PUBLIC_URL + "iconfont/back_to_top.svg"}
            onClick={() => {
               window.scrollTo({ top: 0, behavior: "smooth" })
            }} />}
         <BottomComponent />
      </Flex>
   );
}
export default memo(HomeComponent);
